import { Stack } from '@mui/joy';
import { ICellRendererParams, SuppressMouseEventHandlingParams } from 'ag-grid-community';

// Sub-paths, not the barrels: those drag the legacy coreOld graph into every grid test.
import { CopyValueButton } from 'core/elements/CopyValueButton';
import TextLine from 'core/elements/TextLine';
import { Direction } from 'theme/enums';

interface IProps extends ICellRendererParams {
  copyLabel: string;
}

// The value with a button that copies it. An empty value keeps its placeholder: nothing to copy.
export const CopyValueCell = ({ value, valueFormatted, copyLabel }: IProps) => {
  if (!value) {
    return <>{valueFormatted ?? value}</>;
  }

  return (
    <Stack direction={Direction.ROW} sx={{ alignItems: 'center', gap: 0.5, minWidth: 0 }}>
      <TextLine text={valueFormatted ?? String(value)} textEllipsis sx={{ minWidth: 0 }} />

      <CopyValueButton value={String(value)} label={copyLabel} />
    </Stack>
  );
};

// A click on the copy button stays the button's: it does not select the row.
export const isButtonMouseEvent = ({ event }: Pick<SuppressMouseEventHandlingParams, 'event'>) =>
  event?.target instanceof Element && !!event.target.closest('button');
